<template>
  <footer class="position-relative">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-block d-sm-flex justify-content-sm-between">
            <img :src="logoSrc" alt="Logo" class="d-block m-auto m-sm-0">
            <div class="m-auto d-none d-lg-block">
              <b-navbar toggleable="lg" :class="'p-0'">
                <b-navbar-nav>
                  <b-nav-item
                      v-for="menuItem in menu"
                      :key="menuItem.link"
                      @click="scrollToScreen"
                      :href="menuItem.link"
                      :class="'mr-lg-4'">
                    {{ $t(menuItem.name) }}
                  </b-nav-item>
                </b-navbar-nav>
              </b-navbar>
            </div>
            <div class="text-center">
              <b-button class="d-block footer-link mt-4 ml-auto mr-auto text-center" @click="openConfidentialModal">
                {{ $t(locale.policy.link) }}
              </b-button>
              <span class="copy text-center d-block ml-auto mr-auto mt-2">
                                Copyright ©2020. Gemark
                            </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a href="#" class="position-fixed d-none d-lg-block uplink" @click="scrollToTop">
      <img class="d-block ml-auto mr-auto" src="/img/icon-toparrow.svg" alt="">
    </a>
    <modal height="auto"
           :scrollable=true
           name="confidential"
           :adaptive=true
           :class="'confidential-modal'"
    >
      <div class="modal-content">
        <div class="modal-black-header">
          <a href="#" @click="closeConfidentialModal" class="">
            <img class="d-inline" src="/img/icon-cross-dark.svg" alt="">
          </a>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12" v-html="$t(locale.policy.content)"/>
          </div>
        </div>
      </div>
    </modal>
  </footer>
</template>

<script>
import $ from 'jquery';
import App from "@/App";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenFooter',
  data: () => {
    return {
      locale: stringsKeys,
      logoSrc: App.data().globalSettings.logoSrc,
      menu: App.data().menu,
    }
  },
  methods: {
    scrollToTop: function (ev) {
      ev.preventDefault();
      $('html, body').animate({scrollTop: 0}, '300');
    },
    scrollToScreen: function (ev) {
      ev.preventDefault();
      let screenId = ev.target.attributes.href.value;
      if($(screenId).offset()) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(screenId).offset().top
        }, 300);
      } else {
        this.$router.push('/' + screenId);
      }
    },
    openConfidentialModal: function () {
      this.$modal.show('confidential');
    },
    closeConfidentialModal: function (ev) {
      ev.preventDefault();
      this.$modal.hide('confidential');
    }
  }
}
</script>

<style lang="scss">
@import "src/scss/colors";

footer {
  background-color: #2A2B2D;
  padding-top: 40px;
  padding-bottom: 40px;

  .uplink {
    width: 60px;
    height: 60px;
    background: #00D665;
    border-radius: 210px;
    bottom: 90px;
    right: 120px;
    opacity: 0;
    position: relative;
    z-index: 1000;
    @media (min-width: 1800px) {
      bottom: 90px;
    }

    img {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 50%;
    }
  }

  nav {
    &.navbar {
      .navbar-nav {
        .nav-item {
          &:last-child {
            margin-right: 0 !important;
          }
        }

        .nav-link {
          font-family: 'Circe', sans-serif;
          font-weight: normal;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: $white;

          &:hover, &:active, &:visited, &:focus {
            color: $white !important;
          }
        }
      }
    }
  }

  .navbar-expand-lg {
    .navbar-nav {
      display: none !important;
      @media (min-width: 1440px) {
        display: flex !important;
      }

      &.collapsing, &.show {
        display: flex !important;
        width: 100%;
        flex-direction: column;
        right: 0;
        background-color: #242423;
        position: absolute;
        top: 100%;
        z-index: 1;
        padding-top: 30px;

        ul {
          width: 100%;
          flex-direction: column;
          display: flex;
        }

        @media (min-width: 1440px) {
          position: relative;
          background-color: transparent;
          padding-top: 0;
        }
      }
    }
  }

  .copy {
    font-family: "Circe", sans-serif;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: $white;
    opacity: .5;
  }

  .footer-link {
    font-family: "Circe", sans-serif;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: $white;
    opacity: .5;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      padding: 0;
      background: transparent;
      border: none;
    }

    &:active, &:focus {
      padding: 0;
      background: transparent;
      border: none;
    }

    padding: 0;
    background: transparent;
    border: none;
  }

  .confidential-modal {
    .v--modal {
      margin: auto !important;
      left: auto !important;
      right: auto !important;
      top: auto !important;;
      bottom: auto !important;
      width: 100% !important;
      max-width: 890px;
      padding-bottom: 60px !important;

      .modal-content {
        border: none !important;
      }

      @media (min-width: 768px) {
        max-width: 600px;
      }

      h3 {
        font-size: 14px;
      }

      .modal-black-header {
        width: 100%;
        padding-top: 43px;
        padding-bottom: 43px;
        background-color: transparent;
        text-align: right;
        padding-right: 21px;
        @media (min-width: 576px) {
          padding-top: 25px;
          padding-bottom: 41px;
          background-color: transparent;
        }
        @media (min-width: 768px) {
          padding-top: 25px;
          padding-bottom: 21px;
        }
        @media (min-width: 992px) {
          padding-top: 10px;
          padding-bottom: 0;
        }
      }
    }

    ol {
      padding-left: .5rem !important;

      ol {
        padding-left: 1rem;
      }

      &.text-block {
        font-size: 14px;
      }
    }
  }
}

body {
  min-width: 320px;
}
</style>